module.exports = __webpack_public_path__ + "img/LOST-Live-Q.bed2a4d8.jpg";